function trackPageView(event) {
    window.analytics.page(event.payload.path, {path: event.payload.path});
}

function trackServerCall(event) {
    window.analytics.track('serverCall', {
        path: event.payload.path,
        method: event.payload.method,
        elapsedTime: event.payload.elapsedTime,
        requestId: event.payload.requestId,
        channel: event.payload.channel
    });
}

function trackServerCallError(event) {
    window.analytics.track('serverCallError', {
        path: event.payload.path,
        method: event.payload.method,
        elapsedTime: event.payload.elapsedTime,
        errorMessage: event.payload.errorMessage,
        requestId: event.payload.requestId
    });
}

function trackEvent(event) {
    window.analytics.track(event.eventName, event);
}

function trackJourney(event) {
    window.analytics.track('journey', event.payload);
}

function identify(event) {
    window.analytics.identify(event.payload.userId);
}

function trackInputInteraction(elementId) {
    window.analytics.track('fieldInteracted', elementId);
}

function trackPrefill(elementId) {
    window.analytics.track('prefillChanged', elementId);
}

function trackError(error) {
    window.analytics.track('errorGenerated', error);
}

function trackOffering(offering) {
    window.analytics.track('offeringChanged', offering);
}

function trackNavBar(step) {
    window.analytics.track('navbarStepSelected', step);
}

function trackDocumentUpload(document) {
    window.analytics.track('documentUploaded', document);
}

function trackPayment(payment) {
    window.analytics.track('paymentChanged', payment);
}

function trackDocuSign() {
    window.analytics.track('policySigned', {});
}

export default {
    trackPageView,
    trackServerCall,
    trackServerCallError,
    trackEvent,
    trackJourney,
    identify,
    trackInputInteraction,
    trackPrefill,
    trackError,
    trackOffering,
    trackNavBar,
    trackDocumentUpload,
    trackPayment,
    trackDocuSign
};